import MainLayout from "@/components/layout/MainLayout.vue";
import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import { fetchNotificationCount } from "@/services/common/notification-service";

const convertNumberService = new ConvertNumService();

export default {
    name: "manageClass",

    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate
    },
    
    data() {
        return {
            keyword: "",
            classes: {},
            pag_status: false,
            lastPage: "",
            currentPage: ""
        };
    },

    computed: {
        ...mapGetters(["schoolId","teacherId", "studentId", "userType"]),
    },

    methods: {
        search(page = 1) {
            // axios.get("course/manage/search/result?page=" + page, {

            const params = {
                keyword: this.keyword,
            };

            if (this.userType == 'teacher') {
                params.teacher_id = this.teacherId;
            } else if (this.userType == 'school') {
                params.school_id = this.schoolId;
            }

            axios.get("my/course/list/filter?page=" + page, {
                    params: params,
                })
                .then((response) => {
                    this.pag_status = true
                    this.classes = response.data;
                    this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Manage Course Search API Error", error);
                });
        },
        
        getCourseByTeacherId(page = 1) {
            axios.get("my/course/list" + "?page=" + page)
            // axios.get("my/course/list/" + this.teacherId + "?page=" + page)
                .then((response) => {
                    this.classes = response.data;
                    this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course List API error", error);
                });
        },
    },

    filters: {
        truncateCourseName(name) {
            return name.length < 15 ? name : name.substring(0, 15) + '...';
        }
    },

    mounted() {
        this.getCourseByTeacherId();
        fetchNotificationCount();
    }
};
